<div id="engine" #pixiEngine></div>
<input id="myLoad" type="file" style="display:none" />